/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const EvalPythonGraderExecution = {
  PerSample: "per_sample",
  Aggregate: "aggregate",
} as const;
export type EvalPythonGraderExecution = ClosedEnum<
  typeof EvalPythonGraderExecution
>;

/** @internal */
export const EvalPythonGraderExecution$inboundSchema: z.ZodNativeEnum<
  typeof EvalPythonGraderExecution
> = z.nativeEnum(EvalPythonGraderExecution);
/** @internal */
export const EvalPythonGraderExecution$outboundSchema: z.ZodNativeEnum<
  typeof EvalPythonGraderExecution
> = EvalPythonGraderExecution$inboundSchema;
